/**
 * Copies text that is still being fetched to the clipboard.
 * Call it synchronously from the click handler, before any await: Safari only allows clipboard
 * writes while the click is handled, so the pending text is handed to the clipboard as a promise.
 */
export async function copyPendingTextToClipboard(
  text: Promise<string>
): Promise<void> {
  // Browsers without ClipboardItem (Firefox before 127) still accept a write shortly after the click
  if (typeof ClipboardItem === "undefined") {
    await navigator.clipboard.writeText(await text);
    return;
  }

  await navigator.clipboard.write([
    new ClipboardItem({
      // eslint-disable-next-line @typescript-eslint/naming-convention -- MIME type
      "text/plain": text.then(
        (value) => new Blob([value], { type: "text/plain" })
      ),
    }),
  ]);
}
